/**
 * useLeads — list of leads scoped to a user.
 *
 * Used by DashboardV2 (the kanban) and any future leads list. Mutations
 * still go directly through `supabase.from('leads').update()`; pair them
 * with `queryClient.setQueryData(['leads', userId], next)` for optimistic
 * UI. See README.md for the rationale (mutations layer is a follow-up
 * PR).
 *
 * Sort order matches V2's prior behavior: created_at desc — newest at
 * the top of the kanban backlog.
 */
import { useQuery } from '@tanstack/react-query'
import { supabase } from '../supabase'

export const leadsQueryKey = (userId) => ['leads', userId]

export async function fetchLeads(userId) {
  if (!userId) return []
  const { data, error } = await supabase
    .from('leads')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
  if (error) throw error
  return data || []
}

export function useLeads(userId, opts = {}) {
  return useQuery({
    queryKey: leadsQueryKey(userId),
    queryFn: () => fetchLeads(userId),
    enabled: !!userId && (opts.enabled ?? true),
    ...opts,
  })
}

export default useLeads
